<div #ref class="mx-4 pb-6 cursor-pointer font-medium" (click)="scrollToElement()">{{ title }}</div>
